export enum SyncRules {
    FillSurvey = 'contest.fill-survey',
    RegisterInContest = 'contest.register-in-contest',
    RegisterGroupsInContest = 'contest.register-groups-in-contest',
    ShareCodeInContest = 'contest.share-code-in-contest',
    CompeteInContest = 'contest.compete-in-contest',
    RegisterInCollectiveContest = 'contest.register-in-collective-contest',
    RegisterInIndividualContest = 'contest.register-in-individual-contest',
}